<template>
  <div class="points-card">
    <div class="points-card-body">
      <i class="uil-coins points-icon"></i>
      <div class="points-values">
        <span class="points-number">{{ userPoint }} / {{ userCoin }}</span>
        <span class="points-label">{{ $t("gift.point_have") }} / {{ $t("gift.coin_have") }}</span>
      </div>
    </div>
    <div v-if="userPoint > 0 && !loading" class="points-card-footer">
      <button class="convert-btn" type="button" @click="$emit('convert-coin')">
        <i class="uil-coins"></i>
        {{ $t('gift.convert_to_coins') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GiftPointsCard",
  props: {
    userPoint: {
      type: [Number, String],
      default: 0
    },
    userCoin: {
      type: [Number, String],
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.points-card {
  background: var(--backgroundColor, #6366f1);
  border: 1px solid transparent;
  border-radius: 12px;
  padding: 1.5rem 1rem 1rem 1rem;
  color: #fff;
  box-shadow: none;
  position: relative;
}

.points-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 4px;
}

.points-icon {
  position: absolute;
  top: -22px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1.8rem;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: var(--backgroundColor, #6366f1);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: none;
}

.points-values {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.points-number {
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.points-label {
  font-size: 0.8rem;
  opacity: 0.85;
}

.points-card-footer {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.convert-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--backgroundColor, #6366f1);
  background: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.convert-btn:hover {
  background: #f3f4f6;
  transform: translateY(-1px);
}

.convert-btn i {
  font-size: 1rem;
}

@media (max-width: 1024px) {
  .points-card {
    padding: 1.2rem 1rem 0.8rem 1rem;
    margin-top: 20px;
  }

  .points-icon {
    top: -20px;
    width: 40px;
    height: 40px;
    font-size: 1.6rem;
  }

  .points-number {
    font-size: 1.3rem;
  }

  .points-label {
    font-size: 0.75rem;
  }

  .convert-btn {
    padding: 8px 16px;
    font-size: 0.8rem;
  }
}

@media (max-width: 768px) {
  .points-card {
    padding: 1rem 0.8rem 0.8rem 0.8rem;
    margin-top: 0;
  }

  .points-icon {
    top: -18px;
    width: 36px;
    height: 36px;
    font-size: 1.4rem;
    border-radius: 10px;
  }

  .points-values {
    align-items: center;
    text-align: center;
  }

  .points-number {
    font-size: 1.1rem;
  }

  .points-label {
    font-size: 0.7rem;
  }

  .points-card-footer {
    margin-top: 10px;
  }

  .convert-btn {
    width: 100%;
    justify-content: center;
    padding: 8px 12px;
    font-size: 0.75rem;
  }
}

@media (max-width: 576px) {
  .points-card {
    padding: 1rem 0.8rem 0.8rem 0.8rem;
    margin-top: 18px;
    border-radius: 10px;
  }

  .points-card-body {
    justify-content: center;
    gap: 2px;
  }

  .points-icon {
    top: -16px;
    width: 32px;
    height: 32px;
    font-size: 1.2rem;
    border-radius: 8px;
  }

  .points-number {
    font-size: 1rem;
  }

  .points-label {
    font-size: 0.65rem;
  }

  .points-card-footer {
    margin-top: 8px;
  }

  .convert-btn {
    padding: 6px 12px;
    font-size: 0.7rem;
    border-radius: 6px;
  }
}

@media (max-width: 400px) {
  .points-card {
    padding: 0.8rem 0.6rem 0.6rem 0.6rem;
    margin-top: 14px;
  }

  .points-icon {
    top: -14px;
    width: 28px;
    height: 28px;
    font-size: 1rem;
    border-radius: 6px;
  }

  .points-number {
    font-size: 0.9rem;
  }

  .points-label {
    font-size: 0.6rem;
  }

  .convert-btn {
    padding: 5px 10px;
    font-size: 0.65rem;
  }
}

@media (max-width: 576px) {
  .points-card {
    padding: 20px 16px 16px;
    border-radius: 12px;
  }

  .points-icon {
    top: -20px;
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .points-number {
    font-size: 20px;
    line-height: 1.25;
  }

  .points-label {
    font-size: 14px;
    line-height: 1.5;
  }

  .convert-btn {
    width: 100%;
    min-height: 48px;
    justify-content: center;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 1.25;
  }
}
</style>
